$(function() {

    $('.filter-toolbar').click(e => {
        const target = e.currentTarget;
        const type = $(target).data('role');
        if (type == 'hide') {
            $('.facets-vertical-form').removeClass('show-filters').addClass('hide-filters');
            $('.facets-vertical').removeClass('show-filters').addClass('hide-filters');

            $('#product-grid').removeClass('grid--3-col-desktop').addClass('grid--4-col-desktop');
        }
        if (type == 'show') {
            $('.facets-vertical-form').removeClass('hide-filters').addClass('show-filters');
            $('.facets-vertical').removeClass('hide-filters').addClass('show-filters');

            $('#product-grid').removeClass('grid--4-col-desktop').addClass('grid--3-col-desktop');
        }
    })
});
